export type PassportLayout = {
  title: string
  titleColor: string
  titleSize: number
}

const DEFAULT_LAYOUT: PassportLayout = {
  title: '',
  titleColor: '#000000',
  titleSize: 16,
}

function normalizeHexColor(color: unknown): string {
  if (typeof color !== 'string') {
    return DEFAULT_LAYOUT.titleColor
  }
  const value = color.trim()
  if (/^#[0-9a-fA-F]{6}$/.test(value)) {
    return value
  }
  if (/^#[0-9a-fA-F]{3}$/.test(value)) {
    const r = value[1]
    const g = value[2]
    const b = value[3]
    return `#${r}${r}${g}${g}${b}${b}`
  }
  return DEFAULT_LAYOUT.titleColor
}

function normalizePassportLayout(layout: Record<string, unknown> = {}): PassportLayout {
  const titleSize = Number(layout?.titleSize)
  return {
    title: typeof layout?.title === 'string' ? layout.title : '',
    titleColor: normalizeHexColor(layout?.titleColor),
    titleSize: Number.isFinite(titleSize) && titleSize > 0 ? titleSize : DEFAULT_LAYOUT.titleSize,
  }
}

export function parsePassportLayout(raw: unknown): PassportLayout {
  if (!raw) {
    return normalizePassportLayout()
  }
  if (typeof raw === 'object') {
    return normalizePassportLayout(raw as Record<string, unknown>)
  }
  if (typeof raw !== 'string') {
    return normalizePassportLayout()
  }
  try {
    return normalizePassportLayout(JSON.parse(raw))
  } catch {
    return normalizePassportLayout()
  }
}

type PublicPassportPayload = {
  Name?: string
  name?: string
  LayoutParameters?: unknown
  layoutParameters?: unknown
  SmallImageUrl?: string
  smallImageUrl?: string
  MediumImageUrl?: string
  mediumImageUrl?: string
  LargeImageUrl?: string
  largeImageUrl?: string
  Devices?: unknown[]
  devices?: unknown[]
}

export function visitorPassportSnapshot(passport: PublicPassportPayload | null | undefined) {
  const layout = parsePassportLayout(passport?.LayoutParameters ?? passport?.layoutParameters)
  return {
    title: passport?.Name ?? passport?.name ?? '',
    imageSmall: passport?.SmallImageUrl ?? passport?.smallImageUrl,
    imageMedium: passport?.MediumImageUrl ?? passport?.mediumImageUrl,
    imageLarge: passport?.LargeImageUrl ?? passport?.largeImageUrl,
    devices: passport?.Devices ?? passport?.devices ?? [],
    layoutTitle: layout.title,
    titleColor: layout.titleColor,
    titleSize: layout.titleSize,
  }
}
